import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["new", "contacted", "closed"];

export default function AdminEnquiries() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/enquiries").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/enquiries/${id}`, { status });
    toast.success("Updated");
    load();
  };

  return (
    <div>
      <div className="overline">Inbound</div>
      <h1 className="font-display text-4xl mt-2 mb-8">Enquiries ({list.length})</h1>

      <div className="space-y-4">
        {list.map((e) => (
          <div key={e.id} className="bg-white border border-[var(--fm-border)] p-6">
            <div className="flex justify-between flex-wrap gap-3">
              <div>
                <div className="font-display text-lg">{e.name}{e.clinic_name ? ` — ${e.clinic_name}` : ""}</div>
                <div className="text-xs text-[var(--fm-text-3)] mt-1">{e.email} · {e.phone}{e.city ? ` · ${e.city}` : ""}</div>
                {e.product_name && <div className="overline mt-2 text-[var(--fm-accent)]">RE: {e.product_name}</div>}
              </div>
              <select data-testid={`enq-status-${e.id}`} value={e.status} onChange={(ev) => updateStatus(e.id, ev.target.value)} className="border border-[var(--fm-border)] px-2 py-1 text-xs h-fit bg-white">
                {STATUSES.map((s) => <option key={s}>{s}</option>)}
              </select>
            </div>
            <p className="text-sm text-[var(--fm-text-2)] mt-4">{e.message}</p>
            <div className="text-[10px] text-[var(--fm-text-3)] mt-3">{new Date(e.created_at).toLocaleString("en-IN")}</div>
          </div>
        ))}
        {list.length === 0 && <div className="border border-dashed border-[var(--fm-border)] p-12 text-center text-sm text-[var(--fm-text-2)]">No enquiries yet.</div>}
      </div>
    </div>
  );
}
